<template>
    <v-card max-width="700" min-width="500" v-if="activeCompanyBanks">
        <v-card-title>{{ "Integration info" | t }}</v-card-title>

        <v-card-text v-if="activeCompany && Object.keys(activeCompany).length > 0" class="pb-0">
            <div class="subtitle-1">
                {{ "Client ID" | t }}: {{ activeCompany.client_id ? activeCompany.client_id : "-" }}
            </div>
            <div class="subtitle-1">
                {{ "Include payer IBAN to postback" | t }}: {{ activeCompany.meta && activeCompany.meta.postback && activeCompany.meta.postback.payer_iban ? "Yes" : "No" }}
            </div>
            <div class="subtitle-1">
                {{ "Include payer name to postback" | t }}: {{ activeCompany.meta && activeCompany.meta.postback && activeCompany.meta.postback.payer_name ? "Yes" : "No" }}
            </div>
            <div v-if="activeCompanyBanks">
                <div v-for="item in activeCompanyBanks" :key="item.bank_id">
                    <div v-if="item.recipient_iban || item.recipient_name">
                        <div v-if="item.name === 'Stripe' || item.name === 'Placet'">
                            <v-divider v-if="item.is_active" />
                            <div class="subtitle-1" v-if="item.is_active">
                                {{ item.name }} {{ "recipient name" | t }}:
                                {{ item.recipient_name ? item.recipient_name : "-" }}
                            </div>
                        </div>
                        <div v-else>
                            <v-divider />
                            <div class="subtitle-1">
                                {{
                                    `${item.name} ${item.country} ${t("recipient IBAN")}: ${
                                        item.recipient_iban ? item.recipient_iban : "-"
                                    }`
                                }}
                            </div>
                            <div class="subtitle-1">
                                {{
                                    `${item.name} ${item.country} ${t("recipient name")}: ${
                                        item.recipient_name ? item.recipient_name : "-"
                                    }`
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </v-card-text>

        <v-divider class="mx-4" />

        <v-card-title v-if="activeCompanyOrigins && activeCompanyOrigins.length > 0"
            >{{ "Access origin" | t }}
        </v-card-title>
        <v-card-text>
            <v-row v-for="url in activeCompanyOrigins" :key="url" no-gutters>
                {{ url ? url : "-" }}
            </v-row>
        </v-card-text>

        <v-divider class="mx-4" v-if="activeCompanyOrigins && activeCompanyOrigins.length > 0" />

        <v-card-title v-if="activeCompanyAllowedIbans && activeCompanyAllowedIbans.length > 0"
            >{{ "Allowed IBANs" | t }}
        </v-card-title>
        <v-card-text>
            <v-row v-for="iban in activeCompanyAllowedIbans" :key="iban" no-gutters>
                {{ iban ? iban : "-" }}
            </v-row>
        </v-card-text>

        <v-card-actions v-if="activeUser.company_id && activeUser.company_role === 'owner'">
            <v-spacer />
            <v-btn color="black" text @click="handleEditClick">
                {{ "Edit" | t }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "integration-card",
    computed: {
        ...mapState([
            "activeUser",
            "activeCompany",
            "activeCompanyBanks",
            "activeCompanyOrigins",
            "activeCompanyAllowedIbans"
        ])
    },
    methods: {
        handleEditClick() {
            this.$router.push({ name: "integration-edit" });
        }
    }
};
</script>

<style scoped></style>
